export default __webpack_public_path__ + "ae54df38188d0bb2fc76878f29b2847b.png";